// ---------------------------------------------------------------------------
// Strapi `blocks.hubspot-form` → HubSpotFormBlockComponent input adapter.
//
// Component UID shape (see .guillaume/specs/strapi-to-frontend/23-hubspot-form.md):
//   { id, portalId, formId, region: 'eu1' | 'na1', heading?, intro? }
//
// `_baseUrl` is intentionally unused — HubSpot is a third-party origin and
// never needs Strapi media URL resolution. The prefix satisfies the lint
// rule and matches conventions in adapters that accept the uniform
// (entry, baseUrl) signature.
// ---------------------------------------------------------------------------

export function adaptHubSpotFormBlock(
  entry: Record<string, unknown>,
  _baseUrl: string,
): Record<string, unknown> {
  const region = entry['region'] === 'na1' ? 'na1' : 'eu1';
  return {
    portalId: String(entry['portalId'] ?? ''),
    formId: String(entry['formId'] ?? ''),
    region,
    heading: (entry['heading'] as string) ?? '',
    intro: (entry['intro'] as string) ?? '',
    blockId: (entry['id'] as number) ?? 0,
  };
}
